/* eslint-disable no-useless-return */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/button-has-type */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable consistent-return */

import React, { useEffect, useState } from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';
import { isEmpty } from 'ramda';
import nextSVG from '../icons/next.svg';
import prevSVG from '../icons/prev.svg';
import playSVG from '../icons/playcircle.svg';
import VideoPopup from '../../shared/VideoPopup';
import { trackEvent } from '../../../utils/analytics';
import EventNames from '../../../utils/event-name-constants';
import { useFirebase } from '../../../contexts/ssr-firebase-context';

function HomeTopSlider({ pageType, promoSlides = [] }) {
  const { remoteConfig: remoteConfigData } = useFirebase();
  let parsedConfig;
  if (process.env.NEXT_PUBLIC_HOME_REMOTE_CONFIG_ENV === 'UAT') {
    parsedConfig = remoteConfigData?.web_home_uat || [];
  }
  if (process.env.NEXT_PUBLIC_HOME_REMOTE_CONFIG_ENV === 'BETA') {
    parsedConfig = remoteConfigData?.web_home_beta || [];
  }
  if (process.env.NEXT_PUBLIC_HOME_REMOTE_CONFIG_ENV === 'PROD' || process.env.NEXT_PUBLIC_HOME_REMOTE_CONFIG_ENV === 'PREPROD') {
    parsedConfig = remoteConfigData?.web_home_prod || [];
  }
  // console.log('remoteConfigData abnner', typeof remoteConfigData);
  const bannerData = parsedConfig?.data?.filter((item) => item.type === 'banner') || [];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false); // Track hover state
  const [startX, setStartX] = useState(null); // Track start position (mouse/touch)
  const [endX, setEndX] = useState(null); // Track end position (mouse/touch)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentVideoUrl, setCurrentVideoUrl] = useState(null);
  const { PROMOTIONAL_BANNER_CLICKED } = EventNames;
  const slides = isEmpty(promoSlides) ? bannerData?.[0]?.data || [] : promoSlides;
  // console.log('slides', slides);
  useEffect(() => {
    if (!isPaused) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex === slides.length - 1 ? 0 : prevIndex + 1));
      }, 4000);

      return () => clearInterval(interval);
    }
  }, [isPaused, slides.length]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? slides.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex === slides.length - 1 ? 0 : prevIndex + 1));
  };

  const handleStart = (position) => {
    setStartX(position);
  };

  const handleSwipe = (endPosition) => {
    if (startX !== null && endPosition !== null) {
      const swipeDistance = startX - endPosition;

      // Swipe threshold: Only trigger if swipe is more than 50px
      if (swipeDistance > 50) {
        handleNext(); // Swipe left
      } else if (swipeDistance < -50) {
        handlePrev(); // Swipe right
      }

      // Reset positions
      setStartX(null);
      setEndX(null);
    }
  };
  const handleEnd = (position) => {
    setEndX(position);
    handleSwipe(position); // Calculate swipe direction
  };

  const handleMouseDown = (e) => handleStart(e.clientX);
  const handleMouseUp = (e) => handleEnd(e.clientX);

  const handleTouchStart = (e) => handleStart(e.touches[0].clientX);
  const handleTouchEnd = (e) => handleEnd(e.changedTouches[0].clientX);
  // console.log('endX ', endX);

  const getVideoIDFromYtUrl = (url) => {
    // eslint-disable-next-line no-useless-escape
    const videRegEx = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    // console.log('id ', url.match(videRegEx)[1])
    return url.match(videRegEx)[1];
  };
  const openModal = (videoUrl) => {
    console.log('testing', videoUrl);
    const id = getVideoIDFromYtUrl(videoUrl);
    const youtubeEmbedURL = `https://www.youtube.com/embed/${id}?autoplay=1`;
    // setCurrentVideoUrl('https://www.youtube.com/embed/mom1w5M0hns');
    setCurrentVideoUrl(youtubeEmbedURL);
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentVideoUrl(null);
  };

  const handleClickVideo = (videoUrl) => {
    openModal(videoUrl);
  };

  const handleClick = (url, type) => {
    if (url) {
      if (type === 'promotional-event') {
        trackEvent(PROMOTIONAL_BANNER_CLICKED, {
          link: url,
        });
      }
      window.open(url, '_blank');
    } else {
      return;
    }
  };

  // if (isLoading) {
  //   return null;
  // }

  return (
    <>
      {isModalOpen && <VideoPopup videoUrl={currentVideoUrl} onClose={closeModal} />}
      <div
        className="relative w-full mx-auto overflow-hidden cursor-pointer"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        {/* Slides */}
        <div className="relative">
          <div
            className="flex transition-transform duration-500"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {slides.map((slide, index) => (
              <div
                key={index}
                className={`${pageType === 'promotional-event' ? '' : 'pr-4'} w-full flex-shrink-0 pt-5 lg:pr-0 lg:pt-3`}
                style={{ width: '100%' }}
              >
                <div className={`${slide.type === 'video' ? 'relative' : 'relative'}`}>
                  <div onClick={() => handleClick(slide.url, slide.type)} className="relative">
                    <div className={`${pageType === 'promotional-event' ? 'bg-[#bbdfff] rounded-[65px] overflow-hidden mb-3 aspect-[3/2.4]' : ''}`}>
                      <Image
                        src={pageType === 'promotional-event' ? slide.bannerImage : slide.desktop_image_url}
                        width={1000}
                        height={1000}
                        priority={index === 0}
                        fetchPriority={index === 0 ? 'high' : 'auto'}
                        sizes="100vw"
                        alt={`Slide ${index}`}
                        className={`${pageType === 'promotional-event' ? 'aspect-[3/2.5] object-contain' : 'aspect-[16/3] object-cover'} hidden sm:block w-full rounded-lg`}
                      />
                      <Image
                        src={pageType === 'promotional-event' ? slide.bannerImage : slide.mweb_image_url}
                        width={1000}
                        height={204}
                        priority={index === 0}
                        fetchPriority={index === 0 ? 'high' : 'auto'}
                        sizes="100vw"
                        alt={`Slide ${index}`}
                        className={`${!pageType === 'promotional-event' ? 'aspect-[2/1]' : '1/1'} sm:hidden w-full object-cover rounded-lg`}
                      />
                    </div>
                    {pageType === 'promotional-event' && (
                      <div className="flex flex-col items-center justify-center">
                        <h3 className="xl:text-2xl lg:text-lg text-md font-[500]">{slide.name}</h3>
                        <span className="xl:text-lg lg:text-md text-md font-[300]">{slide.bio}</span>
                      </div>
                    ) }
                    {/* {slide.type === 'video' && (
                  <>
                    <div className="absolute top-0 left-0 bottom-0 bg-black bg-opacity-50 w-full h-full rounded-lg" />
                    <div className="flex items-center justify-center absolute inset-0 rounded-lg">
                      <Image width={50} height={50} src={playSVG} alt="play" className="w-[45px] lg:w-[90px]" />
                    </div>
                  </>
                  )} */}
                  </div>

                  {slide.type === 'video' && (
                  <div onClick={() => handleClickVideo(slide.url)}>
                    <div className="absolute top-0 left-0 bottom-0 bg-black bg-opacity-50 w-full h-full rounded-lg" />
                    <div className="flex items-center justify-center absolute inset-0 rounded-lg">
                      <Image width={50} height={50} src={playSVG} alt="play" className="w-[45px] lg:w-[90px]" />
                    </div>
                  </div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Controls */}
          {pageType !== 'promotional-event' && (
            <div className="hidden sm:block">
              <Image
                onClick={handlePrev}
                src={prevSVG}
                width={59}
                height={59}
                alt="prev"
                className="absolute top-1/2 left-2 -translate-y-1/2 text-white p-2 focus:outline-none"
              />
              <Image
                onClick={handleNext}
                width={59}
                height={59}
                src={nextSVG}
                alt="next"
                className="absolute top-1/2 right-2 -translate-y-1/2 text-white p-2 focus:outline-none"
              />
            </div>
          )}

        </div>
        {/* Indicators */}
        {
          slides && slides.length > 1 && (
          <div className="flex justify-center mt-4 space-x-2">
            {slides.map((_, index) => (
              <button
                key={index}
                className={`rounded-full ${
                  index === currentIndex ? 'bg-red-500 h-3.5 w-5' : 'bg-gray-300 h-4 w-4'
                }`}
                aria-label={`Go to slide ${index + 1}`}
                onClick={() => setCurrentIndex(index)}
              />
            ))}
          </div>
          )
        }
      </div>
    </>
  );
}
HomeTopSlider.propTypes = {
  pageType: PropTypes.string,
  promoSlides: PropTypes.any,
};

export default HomeTopSlider;
